import * as React from 'react';
import { Cell, Layout } from '@wix/design-system';
import { AppPromoBox } from '../../components/app-promo-box';
import type { AppBoxData } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';
import { ResizeDetectorWrapper } from '../../components/resize-detector-wrapper';
import type {
  ExternalComponentProps,
  ComponentsWithSiteContextProps,
} from '../types';
import { withEssentialsContext } from '../../contexts/essentials-context';
import { VisibilityDetector } from '../visibility-detector';
import { v4 as generateUuidV4 } from 'uuid';
import { withSiteContext } from '../../contexts/site-context';

export interface AppPromoGridProps
  extends ExternalComponentProps,
    ComponentsWithSiteContextProps {
  dataHook?: string;
  apps: AppBoxData[];
  onAppClick?(app: AppBoxData, appIndex: number, impressionId: string): void;
  onAppLoad?(app: AppBoxData, appIndex: number, impressionId: string): void;
  getHref?(appSlug: string, appIndex: number): string | undefined;
}

function AppPromoGridComponent({
  dataHook,
  apps,
  onAppClick,
  onAppLoad,
  getHref,
}: AppPromoGridProps) {
  return (
    <ResizeDetectorWrapper dataHook={dataHook}>
      {({ width }) => {
        const isBigScreen = width > 1155;
        const numOfAppPromoBox = isBigScreen ? 4 : 3;
        return (
          <Layout gap="24px" cols={12}>
            {apps.slice(0, numOfAppPromoBox).map((app, index) => {
              const impressionId = generateUuidV4();
              return (
                <Cell span={12 / numOfAppPromoBox} key={index} rows={1}>
                  <VisibilityDetector
                    onFirstVisible={() => {
                      app && onAppLoad?.(app, index, impressionId);
                    }}
                    style={{ height: '100%' }}
                  >
                    <AppPromoBox
                      dataHook={`${dataHook}-app-promo-box-container-${app.id}`}
                      appData={app}
                      onClick={() => onAppClick?.(app, index, impressionId)}
                      href={getHref?.(app.slug!, index)}
                    />
                  </VisibilityDetector>
                </Cell>
              );
            })}
          </Layout>
        );
      }}
    </ResizeDetectorWrapper>
  );
}

export const AppPromoGrid = withSiteContext(
  withEssentialsContext(AppPromoGridComponent),
);
